<template>
  <div style="height:100%; ">
    <template v-if="allTree !== [] && allTree !==null">
      <div class="role-source-content" v-loading="loading">
        <div class="role-menu-styl">菜单</div>
        <div class="role-source-layout">
          <div class="role-menu-list">
            <div v-for="(menu, index) in allTree" :key="index"
                 class="role-menu-row" :class="{'active': index === active}"
                 @click="privilegeHeadClick(menu.label, index)"
            >
              {{menu.label}}
            </div>
          </div>
          <div class="role-menu-right-content" @scroll="onScroll">
            <div>
              <el-checkbox :disabled="roleId === '100'" v-model="checkAll" :indeterminate="isIndeterminateAll"
                           @change="handleCheckAllChange">全选
              </el-checkbox>
            </div>
            <div v-for="(menu, index) in allTree" :key="index" style="padding-bottom: 8px" :id="menu.label"
                 class="privilege-wrap">
              <div class="role-menu-source">{{menu.label}}</div>
              <el-row class="role-menu-source-row" v-for="(menuItem, indexItem) in menu.children"
                      :key="menuItem.label" :class="{'row-source-top-border': indexItem === 0}">
                <div style="display: flex; flex-direction: row; height: 100%">
                  <div class="role-model-d">
                    <el-checkbox :disabled="roleId === '100'" :key="menuItem.label"
                                 class="role-model-styl" :indeterminate="menuItem.isIndeterminate"
                                 v-model="menuItem.checkAll"
                                 @change="handleModelCheckAllChange($event, index, indexItem)">{{menuItem.label}}
                    </el-checkbox>
                  </div>
                  <div style="flex: 1; line-height: 40px;">
                    <el-checkbox-group v-model="checkedCities" @change="handleCheckedCitiesChange(menuItem)">
                      <el-checkbox
                          :disabled="roleId === '100'"
                          v-for="source in menuItem.children"
                          :label="source.id"
                          :key="source.id"
                          @change="checkedSource(source, menuItem)"
                          class="role-source-styl">
                        {{source.label}}
                      </el-checkbox>
                    </el-checkbox-group>
                  </div>
                </div>
              </el-row>
            </div>

          </div>
        </div>
        <div class="role-source-btn">
          <gj-button :disabled="reduction || roleId === '100'" @click="reductionClick">还原</gj-button>
          <gj-button :disabled="roleId === '100'" type="primary" v-if="$permission('role:upAuthority')"
                    @click="saveResource">保存
          </gj-button>
        </div>
      </div>
    </template>
    
  </div>
</template>
<script>
  import {allAuthTree, upAuthority} from '../../../../../api/setting';
  import {isMeaningful, isMeaningless} from "../../../../../utils/common";

  export default {
    name: "app-role-source",
    data() {
      return {
        loading: false,
        allTree: [],
        checkAll: true,
        isIndeterminateAll: true,
        checkedCities: [],
        active: 0,
        activeStep: null,
        reduction: true,
        checkedCitiesinit: []
      }
    },
    created() {
      this.initSource(this.roleId);
    },
    props: ['roleId'],
    watch: {
      roleId: {
        deep: true,  // 深度监听
        handler(newVal, oldVal) {
          this.initSource(newVal);
        }
      }
    },
    methods: {
      handleCheckAllChange(event) {
        this.checkedCities = [];
        this.isIndeterminateAll = false;
        this.checkAll = event;
        const children = [];
        this.allTree.forEach(val => {
          val.children.forEach(v => {
            v.isIndeterminate = false;
            v.checkAll = event;
            const a = v.children.map(k => k.id);
            if (this.checkAll) {
              children.push(...a);
            }
          })
        });
        if (this.checkAll) {
          this.checkedCities = children;
        }
        this.editReduction();
      },
      handleModelCheckAllChange(event, index, indexItem) {
        const keyCheckbox = this.allTree[index].children[indexItem].children.map(v => v.id);
        this.checkedCities = this.checkedCities.filter(v => keyCheckbox.indexOf(v) === -1);
        this.allTree[index].children[indexItem].isIndeterminate = false;
        if (event) {
          this.checkedCities.push(...keyCheckbox);
        }
        this.editReduction();

        this.checkAllFun();
      },
      handleCheckedCitiesChange(menuItem, isCheckAll = true) {
        if (menuItem.children === null) {
          return
        }
        const checkAll = menuItem.children.map(e => e.id).every(id => this.checkedCities.includes(id));
        const isIndeterminate = !checkAll && menuItem.children.map(e => e.id).some(id => this.checkedCities.includes(id));
        this.$set(menuItem, 'checkAll', checkAll);
        this.$set(menuItem, 'isIndeterminate', isIndeterminate);
        this.editReduction();
        if (isCheckAll) {
          this.checkAllFun();
        }
      },
      checkedSource(source, menuItem) {
        // 旧的选择逻辑
        // if (source.sortValue === 1) {
        //   if (!this.checkedCities.includes(source.id) && menuItem.children.length > 1) {
        //     const itemIds = menuItem.children.map(v => v.id);
        //     this.checkedCities = this.checkedCities.filter(v => !itemIds.includes(v));
        //   }
        // } else if (this.checkedCities.includes(source.id) && !this.checkedCities.includes(menuItem.children[0].id)) {
        //   this.checkedCities.push(menuItem.children[0].id);
        // }

        // 新的选择逻辑， 支持一个页面，多个tab权限
        const pageList = menuItem.children.filter(v => v.sortValue === 1 || v.merge) ?.map(i => i.id);
        if (source.sortValue === 1 || source.merge) {//页面取消勾选
            if (!this.checkedCities.includes(source.id) && menuItem.children.length > 1) {
              const includeList = pageList?.filter(v => this.checkedCities.includes(v));
              if(includeList?.length ==0){
                const itemIds = menuItem.children.map(v => v.id);
                this.checkedCities = this.checkedCities.filter(v => !itemIds.includes(v));
              }
            }
        } else if(this.checkedCities.includes(source.id)){//按钮勾选
          pageList?.forEach(v => {
            if (!this.checkedCities.includes(v)){
              this.checkedCities.push(v);
            }
          });
        }
      },
      checkAllFun() {
        // 检查全选按钮
        let allNum = 0;
        this.allTree.forEach(val => {
          if (val.children === null || val.children === [] || val.children.length === 0) {
            return true
          }
          val.children.forEach(v => {
            if(v.children && v.children.length > 0) {
              allNum += v.children.length
            }
          })
        });
        this.checkAll = this.checkedCities.length >= allNum && this.checkedCities.length !== 0;
        this.isIndeterminateAll = !this.checkAll && this.checkedCities.length !== 0;
      },
      privilegeHeadClick(anchor, index) {
        this.active = index;
        this.$nextTick(() => {
          document.querySelector(`#${anchor}`).scrollIntoView({
            block: "start" // 上边框与视窗顶部平齐。默认值
          });
          // behavior: "smooth", // 平滑过渡
        });
      },
      onScroll(e) {
        let scrollItems = document.querySelectorAll(".privilege-wrap");
        for (let i = scrollItems.length - 1; i >= 0; i--) {
          // 判断滚动条滚动距离是否大于当前滚动项可滚动距离
          let judge =
            e.target.scrollTop >=
            scrollItems[i].offsetTop - scrollItems[0].offsetTop;
          if (judge) {
            this.activeStep = i;
            break;
          }
        }
        this.active = this.activeStep;
      },
      editReduction() {
        // 当操作过一次checkbox时还原按钮变为可操作
        if (this.reduction) {
          this.reduction = false;
        }
      },
      reductionClick() {
        this.checkedCities = this.checkedCitiesinit;
        this.allTree.forEach(val => {
          val.children.forEach(v => {
            this.handleCheckedCitiesChange(v, false);
          })
        });
        this.reduction = true;
        this.checkAllFun();
      },
      initSource(roleId) {
        let vm = this;
        this.loading = true;
        allAuthTree(roleId).then(response => {
          let menuList = response.data.menuList;
          // menuList[2].children[2].children[0].children[0].isMerge = true;
          // menuList[2].children[2].children[0].children[1].isMerge = true;
          // menuList[2].children[2].children[1].children[0].isMerge = true;
          // menuList[2].children[2].children[1].children[1].isMerge = true;
          // 菜单（三级+按钮一级） 去掉第二级
          menuList.forEach(val => {
            const list = [];
            if (!isMeaningless(val.children)) {
              val.children.forEach(v => {
                if (isMeaningful(v.children) && v.children.length) {
                  const childList = []
                  v.children.forEach(g => {
                    if (isMeaningful(g.children) && g.children.length > 0) {
                      childList.push(g)
                    }
                  })
                  list.push(...childList)
                }
              })
            }
            val.children = list;
          });
          vm.allTree = menuList;
          vm.checkedCities = response.data.authoritys;
          vm.checkedCitiesinit = response.data.authoritys;
          vm.allTree.forEach(val => {
            val.children.forEach(v => {
              vm.handleCheckedCitiesChange(v, false);
            })
          });
          vm.reduction = true;
          vm.checkAllFun();
        }).complete(() => this.loading = false)
      },
      saveResource() {
        const params = {
          resourceIdList: this.checkedCities,
          roleId: this.roleId
        };
        upAuthority(params).then(response => {
          if (response.isSuccess) {
            this.reduction = true;
            this.checkedCitiesinit = this.checkedCities;
            this.$message.success("操作成功")
          } else {
            this.$message.error("操作失败")
          }
        }).catch(response => {
          this.$message.error("操作失败")
        })
      },
    }
  }

</script>

<style lang="scss" scoped>
  .role-source-content {
    height: 100%;
    // min-width: 1030px;
    border: 1px solid #e8e8e8;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
  }

  .role-source-layout {
    display: flex;
    flex: 1;
    overflow: auto;
    border-bottom: 1px solid #e8e8e8;
  }

  .role-menu-styl {
    background: #f8f8f8;
    color: #666;
    height: 40px;
    line-height: 40px;
    border-bottom: 1px solid #e8e8e8;
    font-size: 14px;
    padding-left: 20px;
  }

  .role-menu-list {
    width: 140px;
    background: #f8f8f8;
    font-size: 14px;
    overflow: auto;
    color: #333;
  }
  .role-menu-right-content {
    padding: 16px;
    flex: 1;
    overflow: auto;
    font-size: 12px;
  }
  .role-menu-list, .role-menu-right-content{
    &::-webkit-scrollbar{
      width: 5px;
      height: 5px;
    }
  }

  .role-menu-row {
    height: 40px;
    line-height: 40px;
    font-weight: 700;
    padding-left: 20px;
    cursor: pointer;
  }

  .role-menu-source {
    font-weight: 700;
    margin-bottom: 16px;
    padding-top: 8px;
    color: #333;
  }

  .role-menu-source-row {
    border-bottom: 1px solid #e8e8e8;
    border-left: 1px solid #e8e8e8;
    border-right: 1px solid #e8e8e8;
    width: 100%;
    background: white;
  }

  .role-model-d {
    width: 140px;
    border-right: 1px solid #e8e8e8;
    display: flex;
  }

  .role-model-styl {
    margin-left: 0;
    line-height: 40px;
    width: 140px;
    padding-left: 10px;
    -webkit-box-sizing: border-box;
    align-items: center;
    display: inherit;
    font-size: 12px;
  }

  .role-source-styl {
    margin-left: 0;
    line-height: 40px;
    width: 140px;
    padding-left: 10px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    display: inline-block;
  }

  .active {
    background: white;
  }

  .row-source-top-border {
    border-top: 1px solid #e8e8e8;
  }

  .role-source-btn {
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px 0;
  }

  /deep/ .el-checkbox__label {
    font-size: 12px;
  }
</style>
